import { useScriptTag } from '@vueuse/core';
import { noop } from '../utils/component-lib.esm.js';
import { defaultWindow } from '../utils/component-lib.esm5.js';
const CALENDLY_WIDGET_URL = 'https://assets.calendly.com/assets/external/widget.js';
let hasLoaded = false;
function useCalendlyWidget() {
  let onLoaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  const window = defaultWindow;

  // only load the SDK once
  if (hasLoaded && window && window.Calendly) onLoaded(window.Calendly);else {
    useScriptTag(CALENDLY_WIDGET_URL, () => {
      hasLoaded = true;
      onLoaded(window.Calendly);
    });
  }
}
export { useCalendlyWidget };